/* eslint-disable jsx-a11y/label-has-for */

import React from 'react';
import { string, bool, func, oneOfType, element } from 'prop-types';
import FormElement from './form-element';

import './radio-button.scss';
import '../utils/hide-visually.scss';

const RadioButton = ({
    className,
    label,
    labelLink,
    labelLinkText,
    isChecked,
    name,
    id,
    dataQ,
    onChange,
    onLabelLinkClick,
    value,
    inline,
    linkDataQ,
    isNewTab,
}) => {
    return (
        <FormElement type="input" inline={inline} className={`gumtree-radio ${className}`}>
            <input
                type="radio"
                value={value}
                name={name}
                data-q={dataQ}
                onChange={onLabelLinkClick ?? onChange}
                checked={isChecked}
                className="radio-switch hide-visually"
                id={`radio-${id}`}
            />
            {labelLink ? (
                <label htmlFor={`radio-${id}`}>
                    {label}
                    <a
                        target={isNewTab ? '_blank' : undefined}
                        rel={isNewTab ? 'noopener noreferrer' : undefined}
                        href={labelLink}
                        data-q={linkDataQ}
                        onClick={(e) => {
                            e.preventDefault();
                            onLabelLinkClick(e);
                        }}
                    >
                        {labelLinkText}
                    </a>
                </label>
            ) : (
                <label htmlFor={`radio-${id}`}>{label}</label>
            )}
        </FormElement>
    );
};

RadioButton.propTypes = {
    className: string,
    dataQ: string,
    id: string.isRequired,
    inline: bool,
    isChecked: bool,
    isNewTab: bool,
    label: oneOfType([string, element]).isRequired,
    labelLink: string,
    labelLinkText: oneOfType([string, element]),
    linkDataQ: string,
    name: string.isRequired,
    onChange: func,
    onLabelLinkClick: func,
    value: string,
};

RadioButton.defaultProps = {
    className: '',
    dataQ: null,
    linkDataQ: null,
    inline: false,
    isChecked: undefined,
    isNewTab: true,
    labelLink: null,
    labelLinkText: null,
    onChange: () => {},
    onLabelLinkClick: undefined,
    value: '',
};

export default RadioButton;
